﻿function getQueryString(field, url) {
    var href = url ? url : window.location.href;
    var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    var string = reg.exec(href);
    return string ? string[1] : null;
};

function ajaxGet(url, parseJson, noCache) {
    return new Promise(function (resolve, reject) {
        const req = new XMLHttpRequest();

        if (noCache) {
            if (url.indexOf('?') > -1) {
                url = url + '&t=' + new Date().getTime();
            } else {
                url = url + '?t=' + new Date().getTime();
            }
        }

        req.open("GET", url);
        req.onload = function () {
            if (req.status >= 200 && req.status < 300) {
                resolve(parseJson ? JSON.parse(req.response) : req.response);
            } else {
                reject(new Error(req.statusText));
            }
        };

        req.onerror = function () {
            reject(new Error("Network error"));
        };

        req.send();
    });
}

export { getQueryString, ajaxGet }